import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { createCollectSizesRequest, resetPopupWizard } from '../../../../../redux/collect-sizes/collect-sizes.actions';
import { isUserCreatedCollectSizesBeforeSelector } from '../../../../../redux/collect-sizes/collect-sizes.selectors';
import { isLimitedEditionSelector } from '../../../../../redux/product/product.selectors';
import { CollectionNameDialog as CollectionNameDialogComponent } from './collection-name-dialog';
const mapStateToProps = createStructuredSelector({
  isGreetingsStepSkipped: isUserCreatedCollectSizesBeforeSelector,
  isLimitedEdition: isLimitedEditionSelector
});
const mapDispatchToProps = dispatch => ({
  onNext: name => {
    dispatch(createCollectSizesRequest(name));
  },
  onBack: () => {
    dispatch(resetPopupWizard());
  }
});
export const CollectionNameDialog = connect(mapStateToProps, mapDispatchToProps)(CollectionNameDialogComponent);